import { toAbsoluteUrl } from "../utils/AssetHelpers";
import Icon from "../components/Icon";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { logout as logoutAPI } from "../api/auth";
import { profileShow } from "../api/RecordInvoiceAPI";

const logoutIcon = (
  <Icon icon="arrow-right-from-bracket" className="fa-fw" />
);

const userIcon = (
  <Icon icon="user" className="fa-fw" />
);

const Nevbar = () => {
  const navigate = useNavigate();
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const [user, setUser] = useState({
    name: "",
    id: 0,
  });

  useEffect(() => {
    const getData = async () => {
      // ดึง customer.id จาก localStorage ที่เก็บไว้ตอน login
      const customerId = localStorage.getItem('customerId');
      const customerIdNumber = customerId ? parseInt(customerId) : 0;

      if (customerIdNumber > 0) {
        const res: any = await profileShow(customerIdNumber);
        const apiData: any = res.data || {};
        setUser({
          name: apiData?.customer?.name || "",
          id: apiData?.id || 0,
        });
      }
    }
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const logout = async () => {
    if (isLoggingOut) return; // ป้องกันการกดซ้ำ

    try {
      setIsLoggingOut(true);
      // เรียก API logout
      await logoutAPI();

      // ลบ customerId ออกจาก localStorage
      localStorage.removeItem('customerId');

      // นำทางกลับไปหน้า login
      navigate('/');
    } catch (error) {
      console.error('Logout failed:', error);
      // แม้เกิด error ก็ให้ลบ token และ customerId แล้วกลับไปหน้า login
      localStorage.removeItem('customerId');
      navigate('/');
    } finally {
      setIsLoggingOut(false);
    }
  };

  return (
    <nav className="navbar-custom">
      <div className="navbar-container">
        {/* Left side: Logo and system name */}
        <div className="navbar-brand-section">
          <img
            src={toAbsoluteUrl("/images/logo.webp")}
            className="navbar-logo"
            alt="logo"
          />
          <div className="navbar-title-group">
            <span className="navbar-title-main">
              ระบบตรวจสอบข้อมูลผู้ใช้น้ำ
            </span>
            <span className="navbar-title-sub">
              Water Meter System
            </span>
          </div>
        </div>

        {/* Right side: User info and logout button */}
        <div className="navbar-actions">
          {/* User info */}
          <div className="navbar-user-info">
            {user.name && (
              <>
                <span className="navbar-user-icon">{userIcon}</span>
                <span className="navbar-user-name">{user.name}</span>
              </>
            )}
          </div>

          {/* Logout button */}
          <button
            type="button"
            className="navbar-logout-btn"
            onClick={logout}
            disabled={isLoggingOut}
          >
            <span className="navbar-logout-icon">{logoutIcon}</span>
            <span className="navbar-logout-text">
              {isLoggingOut ? 'กำลังออก...' : 'ออกจากระบบ'}
            </span>
          </button>
        </div>
      </div>
    </nav>
  );
};

export { Nevbar };
